import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FavoriteService } from '../../service/favorite.service';
import { FilterService } from '../../service/filter.service';
import { FilterState } from '../../classes/filter.state';
import { Logger } from '../../logging/default-log.service';
import { Product } from '../../classes/product';
import { NgClass } from '@angular/common';

@Component({
    selector: 'productitem-favorite',
    styleUrls: ['./productitem.favorite.component.scss'],
    templateUrl: 'productitem.favorite.component.html',
    standalone: true,
    imports: [NgClass]
})
export class ProductItemFavoriteComponent {
  @Input()
  public product: Product;

  awaitingResponse: boolean = false;

  constructor(
    private filterService: FilterService,
    private favoriteService: FavoriteService,
    private changeDetectorRef: ChangeDetectorRef,
    private logger: Logger
  ) {}

  /**
   * Set or unset favorite status based on current status.
   * Disable button while awaiting response of backend call.
   */
  toggleFavorite() {
    const filterState: FilterState = this.filterService.getFilterState();

    this.awaitingResponse = true;

    this.favoriteService.toggleFavorite(this.product, filterState).subscribe({
      next: (favorite) => {
        this.product.favorite = favorite;
      },
      error: (error) => {
        this.logger.error(
          'Failed to toggle favorite for ' + this.product.totalDescription1,
          error
        );
      },
      complete: () => {
        this.awaitingResponse = false;
        this.changeDetectorRef.detectChanges();
      }
    });
  }
}
